import { render, staticRenderFns } from "./promotion-add.vue?vue&type=template&id=05a4b0bf&"
import script from "./promotion-add.vue?vue&type=script&lang=js&"
export * from "./promotion-add.vue?vue&type=script&lang=js&"
import style0 from "./promotion-add.vue?vue&type=style&index=0&id=05a4b0bf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports